import { AppNS } from 'app';

import { getAcknowledgementsByDisciplines } from '../qualifications-sections/sections/acknowledgements/config';
import { isFieldsExcluded } from '../qualifications-sections/sections/section-validation/SectionValidation';

export const isProfileCanBePublished = (company: AppNS.Company): boolean => {
  // Profile can be published when:
  // 1. Company has disciplines
  // 2. Company has price info (either fixed price or proposal price)
  // 3. Company has a merchant account connected and verified
  // 4. Contact info is filled out

  if (!isCompanyHasDisciplines(company)) {
    console.log('Company has no disciplines');
    return false;
  }

  if (!isCompanyHasPriceInfo(company)) {
    console.log('Company has no price info');
    return false;
  }

  if (!isCompanyHasVerifiedMerchantAccount(company)) {
    console.log('Company has no verified merchant account');
    return false;
  }

  if (!isCompanyHasContactInfo(company)) {
    console.log('Company has no contact info');
    return false;
  }

  if (!isCompanyHasAcknowledgementsAccepted(company)) {
    console.log('Company has no accepted acknowledgements');
    return false;
  }

  return true;
};

export const isCompanyHasDisciplines = (company: AppNS.Company): boolean => {
  return company.disciplines && company.disciplines.length > 0;
};

export const isCompanyHasPriceInfo = (company: AppNS.Company): boolean => {
  const disciplinesIds = company.disciplines.map((d) => d.name);
  return (
    isFieldsExcluded(disciplinesIds) || (isCompanyHasFixedPriceInfo(company) || isCompanyHasProposalPriceInfo(company))
  );
};

const isCompanyHasFixedPriceInfo = (company: AppNS.Company): boolean => {
  return company.fixedPriceBookingsEnabled && Boolean(company.fixedPriceList);
};

const isCompanyHasProposalPriceInfo = (company: AppNS.Company): boolean => {
  return company.proposalBookingsEnabled && Boolean(company.pricingPolicy);
};

export const isCompanyHasVerifiedMerchantAccount = (company: AppNS.Company): boolean => {
  return Boolean(company.connectedAccountId);
};

export const isCompanyHasContactInfo = (company: AppNS.Company): boolean => {
  return (
    Boolean(company.pointOfContact) &&
    Boolean(company.contactEmail) &&
    Boolean(company.contactPhone) &&
    Boolean(company.address)
  );
};

export const isCompanyHasAcknowledgementsAccepted = (company: AppNS.Company): boolean => {
  if (isCompanyHasDisciplines(company)) {
    const disciplinesNames = company.disciplines.map((d) => d.name);
    const data = getAcknowledgementsByDisciplines(disciplinesNames);

    const companyAcknowledgements = company.acknowledgements || [];

    return data.every((item) => {
      return companyAcknowledgements.some((ack) => ack.acknowledgementId === item.id && ack.acknowledgedAt);
    });
  }
  return false;
};
